import { render, staticRenderFns } from "./tagLib.vue?vue&type=template&id=0241b00b&scoped=true&"
import script from "./tagLib.vue?vue&type=script&lang=js&"
export * from "./tagLib.vue?vue&type=script&lang=js&"
import style0 from "./tagLib.vue?vue&type=style&index=0&id=0241b00b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0241b00b",
  null
  
)

export default component.exports